import React from 'react'
import { getButton, ButtonColors } from '../Button/Button'
import { getIconButton } from '../IconButton/IconButton'
import * as styles from './Modal.m.css'

const Button = getButton()
const IconButton = getIconButton()

export enum ModalType {
  Ok,
  Confirm,
}

export enum ModalResult {
  Ok,
  Cancel,
}

type Props = {
  title?: string
  children?: React.ReactNode
  type?: ModalType
  okCallback?: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
  cancelCallback?: React.MouseEventHandler<
    HTMLButtonElement | HTMLAnchorElement
  >
  showCloseX?: boolean
}

export const Modal: React.FC<Props> = (props: Props): React.ReactElement => {
  const type = props.type || ModalType.Ok

  let buttons: React.ReactElement

  if (type === ModalType.Ok) {
    buttons = (
      <Button onClick={props.okCallback} color={ButtonColors.Blue}>
        OK
      </Button>
    )
  } else if (type === ModalType.Confirm) {
    buttons = (
      <div>
        <Button onClick={props.cancelCallback} color={ButtonColors.Yellow}>
          Cancel
        </Button>
        <Button onClick={props.okCallback} color={ButtonColors.Blue}>
          OK
        </Button>
      </div>
    )
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <div className={styles.headingContainer}>
          {props.title && <h2 className={styles.modalTitle}>{props.title}</h2>}
          {props.showCloseX &&
            (type === ModalType.Ok ? (
              <IconButton icon="close" onClick={props.okCallback} />
            ) : (
              <IconButton icon="close" onClick={props.cancelCallback} />
            ))}
        </div>
        <div className={styles.modalContent}>{props.children}</div>
        <div className={styles.buttonContainer}>{buttons}</div>
      </div>
    </div>
  )
}
